import styled, { css } from "styled-components";

const DropdownItem = styled.li<{ highlighted?: boolean; disabled?: boolean }>`
  ${({
    theme, highlighted, disabled
  }) => css`
    height: 40px;
    padding: ${theme.spacing.padding.sm};
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 100%;
    background: ${disabled ? theme.colors.lightGrey : highlighted ? theme.colors.primaryDark : "white"};
    pointer-events: ${disabled ? "none" : "all"};

    .details {
      padding: 20px;
    }

    .error {
      color: ${theme.colors.error};
    }

    .emphasize {
      font-weight: bold;
      padding: 20px;
      padding-right: 0;
    }
    
    span {
      color: ${disabled || highlighted ? "white" : theme.colors.primaryDark};
    }
  `}
`;

export default DropdownItem;
